import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./Components/API_Service/Login_Slice";
import Employee from "./Components/API_Service/Employee_Slice";
import settingsReducer from "./Components/API_Service/Settings_Slice";
import Role from "./Components/API_Service/Role_Slice";
import AssociateShiftMappingReducer from "./Components/API_Service/AssociateShiftMapping_Slice";
import Project from "./Components/API_Service/Project_Slice";
import EmailTemplateReducer from "./Components/API_Service/EmailTemplate_Slice";
import HappinessIndexReducer from "./Components/API_Service/HappinessIndexSlice";
import DashboardReducer from "./Components/API_Service/Dashboard_Slice";
import ShiftChangeOverReducer from "./Components/API_Service/ShiftChangeOver_Slice";
const store = configureStore({
  reducer: {
    auth: authReducer,
    employee: Employee,
    settings: settingsReducer,
    role: Role,
    shiftMapping :AssociateShiftMappingReducer,
    project: Project,
    emailTemplate: EmailTemplateReducer,
    happinessIndex: HappinessIndexReducer,
    dashboard:DashboardReducer,
    shiftChangeOver: ShiftChangeOverReducer,
  },
});

export default store;
